<nav
  class="safe-bottom-nav fixed bottom-0 left-0 right-0 z-40 border-t border-[#ece4f3] bg-white/95 px-2 py-1.5 shadow-[0_-2px_10px_rgba(61,38,82,0.05)] backdrop-blur supports-[backdrop-filter]:bg-white/80"
  aria-label="Bottom navigation"
>
  <ul class="mx-auto flex max-w-xl items-stretch justify-between gap-1">
    @for (item of items; track item.Route) {
      <li class="flex-1">
        <a
          [routerLink]="item.Route"
          [class.mobile-bottom-nav__link--active]="isActive(item)"
          class="mobile-bottom-nav__link flex h-full flex-col items-center justify-center gap-1 rounded-xl px-1 py-1.5 text-[0.68rem] font-medium text-[#7a6b8a] transition-colors touch-manipulation"
        >
          <span class="material-icons text-[22px] leading-none">{{ item.Icon }}</span>
          <span class="max-w-[4.5rem] truncate leading-none text-center">
            {{ item.ShortLabel || item.Label || (item.LabelKey | translate) }}
          </span>
        </a>
      </li>
    }
  </ul>
</nav>
